import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {UserSubscription} from "./user-subscription";
import * as fromStore from "../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";

@Injectable()
export class AvailableSubscriptionsResolver implements Resolve<UserSubscription[]> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      if (localStorage.getItem('dbUserAccessToken')) {
        this._store.select(fromStore.getUserLoaded)
          .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getUserAvailableSubscriptions())),
            first()
          )
          .subscribe((data: any) => {
            resolve(data);
          });
        /*this._userService.getAvailablePlans()
          .filter((response: DbResponse): boolean => !!response)
          .first()
          .subscribe((response: DbResponse): void => {
            if (response.success && response.data) {
              resolve(response.data);
            }
            else {
              resolve(null);
            }
          });*/
      }
      else {
        resolve(null);
      }
    });
  }

}
